import passable, { Enforce, test, WARN } from 'passable';
import extendedRules from './extendedRules';

const enforce = new Enforce(extendedRules);

const PATTERNS = {
    EMAIL: /@|\[at\]|\(at\)|\{at\}|\-at\-|\+at\+|\[dot\]|\(dot\)|\{dot\}|\-dot\-|\+dot\+/, // eslint-disable-line
    CONTACT: /email|skype.me|skype|messanger|contact.me.at|send.to.my/i,
    PAYMENT: /paypal|alertpay|money|pay/i
};

export const VALIDATION_ERROR = {
    COMMUNICATION_WARNING: 'communication_warning',
    DIRECT_PAYMENT_WARNING: 'direct_payment_warning',
    TOO_SHORT: 'msg_too_short',
    NON_MEANINGFUL: 'non_meaningful',
    FILES_LOADING: 'files_loading'
};

/**
 * Validation keys for which we show a dedicated error.
 *
 * @type {string[]}
 */
export const ERROR_TYPE_KEYS = [
    VALIDATION_ERROR.FILES_LOADING,
    VALIDATION_ERROR.TOO_SHORT,
    VALIDATION_ERROR.NON_MEANINGFUL
];

export const MIN_MESSAGE_LENGTH = 40;

export const validateForm = ({
    message,
    attachments,
    sellerName
}) => passable('SendMessage', () => {

    test('message', VALIDATION_ERROR.COMMUNICATION_WARNING, () => {
        enforce(message)
            .notMatches(PATTERNS.EMAIL)
            .notMatches(PATTERNS.CONTACT);
    }, WARN);

    test('message', VALIDATION_ERROR.DIRECT_PAYMENT_WARNING, () => {
        enforce(message).notMatches(PATTERNS.PAYMENT);
    }, WARN);

    test('message', VALIDATION_ERROR.TOO_SHORT, () => {
        enforce(message).longerThanOrEquals(MIN_MESSAGE_LENGTH);
    });

    test('message', VALIDATION_ERROR.NON_MEANINGFUL, () => {
        enforce(message).notMeaningful(sellerName);
    });

    test('attachments', VALIDATION_ERROR.FILES_LOADING, () => attachments.every(
        (attachment) => !!attachment.loaded
    ));
});
